import { getContext, setContext } from 'svelte';

import type { FifaLoginFlowContext } from './types';

const FIFA_LOGIN_FLOW_CONTEXT = Symbol('fifa-login-flow');

export const setFifaLoginFlowContext = (context: FifaLoginFlowContext) => {
    setContext(FIFA_LOGIN_FLOW_CONTEXT, context);
    setPassportSdkEnsurer(context.ensurePassportSdk);
};

export const getFifaLoginFlowContext = (): FifaLoginFlowContext => {
    const context = getContext<FifaLoginFlowContext | undefined>(
        FIFA_LOGIN_FLOW_CONTEXT
    );

    if (!context) {
        throw new Error('[fifaLogin] FifaLoginFlowContext is not initialized');
    }

    return context;
};

let passportSdkEnsurer: () => void = () => {
    if (typeof window === 'undefined' || !window.login) {
        throw new Error('[fifaLogin] Passport SDK is not ready');
    }
};

export const setPassportSdkEnsurer = (ensurer: () => void) => {
    passportSdkEnsurer = ensurer;
};

export const ensurePassportSdk = () => passportSdkEnsurer();
